import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef, memo } from "react";
import { resolveCss, } from "../system";
import { useTheme } from "./ThemeProvider";
export const BaseComponent = memo(forwardRef(({ as, sx, children, ...props }, ref) => {
    const Component = as || "div";
    //Used during the mui theme deprecation because of the conflicting react context
    const theme = useTheme();
    return (
    // <Component ref={ref} css={(theme) => resolveCss({ theme, sx })}>
    _jsx(Component, { ...props, ref: ref, css: resolveCss({ theme, sx }), children: children }));
}));
//# sourceMappingURL=BaseComponent.js.map